import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { createBankPromptMenuItem, PROMPT_MENU_TYPE } from '../../lib';
import { BaseItemsList } from '../BaseItemsList';
import { MenuItem } from '../MenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  bankResources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  isApplicationModeInfinity: PropTypes.bool,
  quickSearchMode: PropTypes.bool,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  isApplicationModeInfinity: false,
  quickSearchMode: false,
  noTags: false,
};

export const ItemsBank = ({
  className,
  bankResources,
  onAction,
  isApplicationModeInfinity,
  quickSearchMode,
  noTags,
}) => {
  const styles = useStyles();

  const menuItems = useMemo(
    () => (bankResources || []).map(createBankPromptMenuItem),
    [bankResources]
  );

  return (
    <BaseItemsList className={cx(styles.root, className)}>
      {menuItems.map((item) => (
        <MenuItem
          key={item.id}
          type={PROMPT_MENU_TYPE.bank}
          item={item}
          onAction={onAction}
          menuType={PROMPT_MENU_TYPE.bank}
          isApplicationModeInfinity={isApplicationModeInfinity}
          quickSearchMode={quickSearchMode}
          noTags={noTags}
        />
      ))}
    </BaseItemsList>
  );
};

ItemsBank.displayName = 'ItemsBank';
ItemsBank.propTypes = propTypes;
ItemsBank.defaultProps = defaultProps;
